import axios from 'axios';
import logger from "./utils/logger";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  withCredentials: true,
});

// Pre-session endpoints: a 401 here means "bad credentials" / "no session yet",
// not "session expired" — don't run the refresh dance for these.
const AUTH_BOOTSTRAP_PATHS = [
  "/auth/publicKey",
  "/auth/doctors/login",
  "/auth/staff/login",
  "/auth/doctors/accept-terms",
  "/auth/doctors/contract",
];

const isAuthBootstrapRequest = (config) =>
  AUTH_BOOTSTRAP_PATHS.some((path) => config?.url?.includes(path));

// Response Interceptor: silently refresh the access-token cookie on 401 and retry once.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isAuthBootstrapRequest(originalRequest)
    ) {
      originalRequest._retry = true;

      try {
        // Plain axios (not the `api` instance) so a 401 on the refresh call
        // itself doesn't re-enter this same interceptor and recurse.
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        return api(originalRequest);
      } catch (refreshError) {
        logger.debug("Session refresh failed", refreshError.message);
        window.dispatchEvent(new Event("session-expired"));
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
